// imports
import $ from 'jquery';
import md5 from 'md5';

class SEO {
  constructor() {
    this.LOGGING = false;
    this.HEADER_PHONE = '.js-events__phone';
    this.QUICK_ESTIMATE_BUTTON = 'a[href*="pricing"].button, .js-events__quick-estimate-button';
    this.GET_A_CALL_BUTTON = '.js-events__call-button, .home .slidecontent a[href*="tel"]';
	  this.CONTACT_FORM = 'body.contact .block--form form';
	
	this.PHONE_CALL_VALUE = 135; // Organic Phone Value
	this.ad = false;
	this.wizardValueTotal = 0;

	this.PAGE_TITLE = document.title.replace(' - New Latitude Movers', '');
  }

  trackEvents() {
	
    if (location.search.indexOf('gclid') !== -1 || location.search.indexOf('nlm_campaign') !== -1  || location.search.indexOf('nlm_adgroup') !== -1) {
      localStorage.setItem('ad', true);
  }

	this.ad = localStorage.getItem('ad') === 'true';

	this.PHONE_CALL_VALUE = this.ad ? 68 : 135;
	
	$(this.HEADER_PHONE).on('click', () => this.sendEvent({
      eventCategory: 'engagement',
      eventAction: 'Phone Number Clicked',
	  eventValue: this.PHONE_CALL_VALUE,
	  eventLabel: 'Page: ' + this.PAGE_TITLE,
      fbEventName: 'ViewContent',
    }));

    $(this.QUICK_ESTIMATE_BUTTON).on('click', () => this.sendEvent({
      eventCategory: 'engagement',
	    eventAction: 'Click on Quick Estimate button',
	    eventLabel: 'Page: ' + this.PAGE_TITLE,
      fbEventName: 'ViewContent',
    }));

    $(this.GET_A_CALL_BUTTON).on('click', () => this.sendEvent({
      eventCategory: 'engagement',
	    eventAction: 'Phone Number Clicked',
	    eventLabel: 'Page: ' + this.PAGE_TITLE,
	    eventValue: this.PHONE_CALL_VALUE,
      fbEventName: 'ViewContent',
    }));

    $(this.CONTACT_FORM).on('submit', () => this.sendEvent({
      eventCategory: 'engagement',
	    eventLabel: 'Page: ' + this.PAGE_TITLE,
      eventAction: 'Contact Form Submitted',
      eventValue: 23,
      fbEventName: 'ViewContent',
    }));

    // purechatApi.on('chat:start', () => this.sendEvent({
    //   eventCategory: 'engagement',
    //   eventAction: 'Online Chat',
	//     eventLabel: 'Page: ' + this.PAGE_TITLE,
    //   eventValue: 40,
    //   fbEventName: 'ViewContent',
    // }));
  }

  sendWizardEvent({ eventValue, eventLabel }) {
	let eventAction = 'Moving Estimate';
	if (eventLabel === '1-2 Bedroom Booking') {
		eventAction = 'Quick Price 1-2 BR Booked';
	}
	if (eventLabel === 'Schedule on Site Estimate') {
		eventAction = 'Quick Price On-Site Estimate';
	}
	
	this.sendEvent({
      eventCategory: 'engagement',
      eventAction: eventAction,
      eventValue: eventValue - this.wizardValueTotal,
      eventLabel,
      fbEventName: 'Lead',
      fbContentCategory: 'Wizard',
    });

    this.wizardValueTotal = this.wizardValueTotal + eventValue;
  }

  sendEvent(payload) {
    const {
      eventAction,
      eventCategory,
      eventLabel,
      eventValue,
      fbEventName,
      fbContentCategory,
    } = payload;

    if (this.LOGGING) {
      console.log('🤖', eventAction, payload);
    }

    ga('send', 'event', {
      eventAction,
      eventCategory,
      eventLabel,
      eventValue,
    });

    fbq('track', fbEventName, {
      content_name: eventLabel || eventAction,
      value: eventValue,
      currency: 'USD',
      content_category: fbContentCategory,
    });
  }
};

export default (new SEO());
